<template>
  <div class="contenedor">
    <template>
      <div class="audio">
        <v-btn icon @click="playPauseAudio">
          <v-icon v-if="!currentlyPlaying" :color="invertColor($props.messageColor)"
            >mdi-play-outline</v-icon
          >
          <v-icon v-else-if="currentlyPlaying" :color="invertColor($props.messageColor)"
            >mdi-pause</v-icon
          >
        </v-btn>
        <div>
          <h5
            :style="'color:' + invertColor($props.messageColor)"
            class="currentTimeAndDuration"
          >
            {{ currentTimeShow }} / {{ trackDurationShow }}
          </h5>
        </div>
        <div class="progressbar">
          <v-progress-linear
            :height="5"
            :color="invertColor($props.messageColor)"
            v-model="currentProgressBar"
            @change="seekAudio"
          ></v-progress-linear>
        </div>
        <span @click="downloadAudio" :style="'color:' + invertColor($props.messageColor)" class="download-audio mdi mdi-download"></span>

        <v-btn icon @click="checkSpeed">
          <h5 :style="'color:' + invertColor($props.messageColor)" class="speedLabel">
            {{ speed.toFixed(1) }}x
          </h5>
        </v-btn>
      </div>
    </template>
  </div>
</template>
<script>
import { invertColor } from "@/assets/utils";
export default {
  name: "AudioPlayer",
  props: {
    src: {
      type: String,
      required: true,
    },
    messageColor: String,
  },
  data() {
    return {
      currentTime: 0,
      audio: new Audio(this.$props.src),
      audioDuration: 0,
      currentlyPlaying: false,
      currentProgressBar: 0,
      speed: 1.0,
      invertColor,
    };
  },
  computed: {
    currentTimeShow() {
      return this.timeFormat(Math.ceil(this.currentTime));
    },
    trackDurationShow() {
      return this.timeFormat(Math.ceil(this.audioDuration));
    },
  },
  mounted() {
    this.audio.onloadeddata = () => {
      this.audioDuration = this.audio.duration;
    };
    this.audio.onended = () => {
      this.currentlyPlaying = false;
      this.stopAudio();
      this.currentTime = 0;
    };
  },
  methods: {
    seekAudio() {
      let parseCurrentTime = Math.ceil(
        (this.currentProgressBar * this.audioDuration) / 100
      );
      this.audio.currentTime = parseCurrentTime;
      this.currentTime = parseCurrentTime;
    },
    timeFormat(s) {
      return (s - (s %= 60)) / 60 + (9 < s ? ":" : ":0") + s;
    },
    playPauseAudio() {
      if (!this.currentlyPlaying) {
        this.playAudio();
      } else {
        this.stopAudio();
      }
    },
    playAudio() {
      this.getCurrentTimeEverySecond();
      this.currentlyPlaying = true;
      this.audio.play();
    },
    stopAudio() {
      this.audio.pause();
      this.currentlyPlaying = false;
      clearInterval(this.checkingCurrentPositionInTrack);
    },
    getCurrentTimeEverySecond() {
      this.checkingCurrentPositionInTrack = setInterval(() => {
        this.currentTime = this.audio.currentTime;
        this.currentProgressBar = (this.audio.currentTime / this.audio.duration) * 100;
      }, 100);
    },
    checkSpeed() {
      if (this.speed === 2.0) {
        this.audio.playbackRate = 1.0;
        this.speed = 1.0;
        return;
      }
      this.audio.playbackRate = this.speed + 0.5;
      this.speed += 0.5;
    },
    downloadAudio() {
      var downloadLink = document.createElement("a");

      var audioFilename = "Audio.mp3";
      // Establecer la URL del archivo
      downloadLink.href = this.$props.src;

      // Establecer el nombre del archivo
      downloadLink.download = audioFilename;

      // Agregar el enlace de descarga al DOM y simular el clic
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);
    },
  },
};
</script>
<style>
.contenedor {
  display: flex;
}
.progressbar {
  width: 80px;
}
.download-audio {
  border-radius: 20px;
  cursor: pointer;
}
.audio {
  display: flex;
  align-items: center;
  gap: 3px;
}
.currentTimeAndDuration {
  width: max-content;
}
</style>
